import React from "react";
import { assetUrl } from "../../lib/api";

// Non-destructive crop/zoom adjuster for a headshot. Saves photo_x/y/zoom
// (focal point %, zoom) — shared by Players and Coaches admin so circular
// headshots frame identically everywhere.
export function PhotoCropAdjust({ photoUrl, x = 50, y = 50, zoom = 1, onChange }) {
    const src = assetUrl(photoUrl);
    const previewStyle = {
        objectPosition: `${x}% ${y}%`,
        transform: zoom && zoom !== 1 ? `scale(${zoom})` : undefined,
        transformOrigin: `${x}% ${y}%`,
    };
    return (
        <div className="mt-3 flex items-start gap-4 flex-wrap" data-testid="photo-crop-adjust">
            <div className="h-20 w-20 rounded-full overflow-hidden border border-white/10 bg-black/30 shrink-0">
                <img src={src} alt="preview" className="w-full h-full object-cover" style={previewStyle} data-testid="photo-crop-preview" />
            </div>
            <div className="flex-1 min-w-[220px] space-y-2">
                <div>
                    <label className="text-[10px] uppercase tracking-wider text-[#64748B] flex justify-between"><span>Vertical (top ↔ bottom)</span><span>{Math.round(y)}%</span></label>
                    <input type="range" min="0" max="100" value={y} onChange={(e) => onChange({ photo_y: Number(e.target.value) })} className="w-full accent-[#9D4CDD]" data-testid="photo-crop-y" />
                </div>
                <div>
                    <label className="text-[10px] uppercase tracking-wider text-[#64748B] flex justify-between"><span>Horizontal</span><span>{Math.round(x)}%</span></label>
                    <input type="range" min="0" max="100" value={x} onChange={(e) => onChange({ photo_x: Number(e.target.value) })} className="w-full accent-[#9D4CDD]" data-testid="photo-crop-x" />
                </div>
                <div>
                    <label className="text-[10px] uppercase tracking-wider text-[#64748B] flex justify-between"><span>Zoom</span><span>{Number(zoom).toFixed(2)}×</span></label>
                    <input type="range" min="1" max="2.5" step="0.05" value={zoom} onChange={(e) => onChange({ photo_zoom: Number(e.target.value) })} className="w-full accent-[#9D4CDD]" data-testid="photo-crop-zoom" />
                </div>
                <div className="flex gap-2">
                    <button type="button" onClick={() => onChange({ photo_x: 50, photo_y: 0, photo_zoom: 1 })} className="btn-secondary text-[11px]" data-testid="photo-crop-top">Frame to top</button>
                    <button type="button" onClick={() => onChange({ photo_x: 50, photo_y: 50, photo_zoom: 1 })} className="btn-secondary text-[11px]" data-testid="photo-crop-reset">Reset</button>
                </div>
            </div>
        </div>
    );
}

export default PhotoCropAdjust;
